import * as React from 'react';
import { Container} from "@mui/material";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import ConfirmOrderFooter from '../components/ConfirmOrderFooter.jsx';
import QtyButton from '../components/QtyButton.jsx'
import BackButton from '../components/BackButton.jsx';
import ReviewDishCard from '../components/ReviewDishCard.jsx';
import * as ApiCall from '../ApiCall.jsx';

// loads a page which summarises the current order:
// allows the customer to remove items from their cart or change the quantity of the item
// then confirm the order and send it to the kitchen
export default function CurrentOrder() {

  const [loadState, setLoadState] = React.useState("loading");

  const [order, setOrder] = React.useState({});

  // will show calculating if the load is slow, until the real value is fetched from backend.
  const [total, setTotal] = React.useState(" Calculating...");

  React.useEffect(() => {
    setLoadState("loading");
    //empty the order from last time
    setOrder({});

    let userId = localStorage.getItem('customerId');

    //get the current order details
    ApiCall.get('/customers/orders', 'cId=' + userId)
    .then((orders) => {
      //default no current order
      let state = "nothing";
      for (let i = 0; i < orders.length; i++) {
        //if find a current order,
        //and check that it contains dishes
        //then save the order details
        if (orders[i].isActive === true && 
            Object.keys(orders[i]['dishes']).length != 0) {
          setOrder(orders[i]);
          ApiCall.get("/order/total", "orderId="+orders[i]["id"])
          .then((t) => {
            setTotal(t)            
          })
          .catch((msg) => {alert("Failed to get order total: " + msg)});
          state = "loaded";
        }
      }
      //set the state to relevent one
      // i.e. success if there is an active order
      // nothing if there is currently no active order (nothing added to cart yet)
      setLoadState(state);
    })
    .catch((msg) => {alert("Failed to get customer orders: " + msg)});
  }, [])

  function setDishQty(dishID, qty) {
    // if qty zero, remove it from the order
    if (qty === 0) {
      ApiCall.del("/order/dish", "dishId="+dishID+"&"+"orderId="+order['id'])
      .then((msg) => {
        let copy =  {...order};
        delete copy['dishes'][dishID];
        setOrder(copy);
        if (Object.keys(copy.dishes).length == 0) {
          setLoadState("nothing");
        }
        // recalculate the total
        ApiCall.get("/order/total", "orderId="+order["id"])
        .then((t) => {
          setTotal(t)            
        })
        .catch((msg) => {alert("Failed to get order total: " + msg)});

      })
      .catch((msg) => {alert("Failed to remove dish from order: " + msg)});
    }
    //else update the qty value
    else {
      ApiCall.post("/order/dish", "dishId="+dishID+"&orderId="+order['id']+"&quantity="+qty)
      .then((msg) => {
        let copy = {...order};
        copy['dishes'][dishID]['quantity'] = qty;
        setOrder(copy);
        //recalculate total
        ApiCall.get("/order/total", "orderId="+order["id"])
        .then((t) => {
          setTotal(t)            
        })
        .catch((msg) => {alert("Failed to get order total: " + msg)});
      })
      .catch((msg) => {alert("Failed to change dish quantity: " + msg)});
    }
  }

  //function to return qtty state of a dish
  function getDishQty(dishID) {
    return order['dishes'][dishID].quantity;
  }

  // sets state to complete so can remove the order from the page render
  // otherwise can edit an order after confirming it which doesnt make sense
  function complete() {
    setLoadState("complete");
  }


  // logic to determine what to render
  // kind of repetitive but oh well

  if (loadState === 'loading') {
    return (
      <Box sx={{display: 'flex', flexDirection:'column', height: '100%', alignItems: 'start'}}>
        <BackButton />
        <Box sx={{display: 'flex', flexDirection:'column', width: '100%', alignItems: 'center'}}>
          <CircularProgress />
        </Box>
      </Box>
    )
  }

  if (loadState === 'nothing') {
    return (
    <Box sx={{display: 'flex', flexDirection:'column', height: '100%', alignItems: 'start'}}>
      <BackButton />
      <Box sx={{display: 'flex', flexDirection:'column', width: '100%', alignItems: 'center', p: 3}}>
        <Typography variant="h5">You have not added any items to your order yet.</Typography>
      </Box>
    </Box>
    )
  }

  else {
    
    let content = []
    
    if (loadState === 'loaded') {
      content = (      
        <Container>
          <Box sx={{maxWidth: { sx:1 }, alignItems: 'center'}}>
            <BackButton />
            <Container sx={{maxWidth: { sx:1, md: 3/5 }, pt: 2}}>
              {
                Object.entries(order['dishes']).map(([id, info]) => {
                  return(
                    <Box key={id} sx={{display:'flex', flexDirection:'row', justifyContent: 'space-between' }}>
                      <ReviewDishCard dishInfo={info}></ReviewDishCard>
                      <QtyButton getQty={() => getDishQty(id)} setQty={(qty)=>setDishQty(id, qty)}></QtyButton>
                    </Box>
                  )
                })
              }
            </Container>
          </Box>
        </Container>
      )
    }
    else if (loadState === "complete") {
      content = (
        <Box sx={{display: 'flex', flexDirection:'column', height: '100%', alignItems: 'start'}}>
          <BackButton />
        </Box>
      )
    }

    return (
      <Box sx={{display: 'flex', justifyContent: 'space-between',  flexDirection: 'column', flexWrap: 'nowrap', height: 1, overflowY: "scroll", width: 1}}>
        {content}
        <Container>
          <ConfirmOrderFooter complete={complete} total={total}></ConfirmOrderFooter>
        </Container>
      </Box>
    )
  }
}